import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 21h-2a3 3 0 0 1 -3 -3v-1h5.5","key":"svg-0"}],["path",{"d":"M17 8.5v-3.5a2 2 0 1 1 2 2h-2","key":"svg-1"}],["path",{"d":"M19 3h-11a3 3 0 0 0 -3 3v11","key":"svg-2"}],["path",{"d":"M9 7h4","key":"svg-3"}],["path",{"d":"M9 11h4","key":"svg-4"}],["path",{"d":"M18.42 12.61a2.1 2.1 0 0 1 2.97 2.97l-6.39 6.42h-3v-3z","key":"svg-5"}]]

const IconContract = createReactComponent('outline', 'contract', 'Contract', __iconNode);

export default IconContract;